/**
 * API endpoints para Analytics (Dashboard y Reportes)
 * Base URL: /api/analytics/
 */

import { GET } from "../config";

// ==================== DASHBOARD ====================

/**
 * Obtener dashboard completo
 * @param {number} branchId - ID de la sucursal
 * @param {object} params - Parámetros (start_date, end_date)
 * @returns {Promise} Datos del dashboard
 */
export const getDashboard = async (branchId, params = {}) => {
  let url = `analytics/dashboard/complete/?branch=${branchId}`;

  if (params.start_date) {
    url += `&start_date=${params.start_date}`;
  }

  if (params.end_date) {
    url += `&end_date=${params.end_date}`;
  }

  const response = await GET(url);
  return response.data;
};

/**
 * Obtener resumen del dashboard
 * @param {number} branchId - ID de la sucursal
 * @param {object} params - Parámetros de fecha
 * @returns {Promise} Resumen
 */
export const getSummary = async (branchId, params = {}) => {
  let url = `analytics/dashboard/summary/?branch=${branchId}`;

  if (params.start_date) {
    url += `&start_date=${params.start_date}`;
  }

  if (params.end_date) {
    url += `&end_date=${params.end_date}`;
  }

  const response = await GET(url);
  return response.data;
};

/**
 * Obtener datos de inventario para dashboard
 * @param {number} branchId - ID de la sucursal
 * @returns {Promise} Datos de inventario
 */
export const getInventoryStats = async (branchId) => {
  const response = await GET(`analytics/dashboard/inventory/?branch=${branchId}`);
  return response.data;
};

/**
 * Obtener datos de órdenes para dashboard
 * @param {number} branchId - ID de la sucursal
 * @returns {Promise} Datos de órdenes
 */
export const getOrdersStats = async (branchId) => {
  const response = await GET(`analytics/dashboard/orders/?branch=${branchId}`);
  return response.data;
};

/**
 * Obtener datos de clientes para dashboard
 * @param {number} branchId - ID de la sucursal
 * @returns {Promise} Datos de clientes
 */
export const getCustomersStats = async (branchId) => {
  const response = await GET(`analytics/dashboard/customers/?branch=${branchId}`);
  return response.data;
};

/**
 * Obtener serie temporal de datos
 * @param {number} branchId - ID de la sucursal
 * @param {object} params - Parámetros (metric, period)
 * @returns {Promise} Serie temporal
 */
export const getTimeSeries = async (branchId, params = {}) => {
  let url = `analytics/dashboard/time_series/?branch=${branchId}`;

  if (params.metric) {
    url += `&metric=${params.metric}`;
  }

  if (params.period) {
    url += `&period=${params.period}`;
  }

  const response = await GET(url);
  return response.data;
};

/**
 * Obtener dashboard financiero
 * @param {number} branchId - ID de la sucursal
 * @param {object} params - Parámetros de fecha
 * @returns {Promise} Datos financieros
 */
export const getFinancialDashboard = async (branchId, params = {}) => {
  let url = `analytics/financial-dashboard/?branch=${branchId}`;

  if (params.start_date) {
    url += `&start_date=${params.start_date}`;
  }

  if (params.end_date) {
    url += `&end_date=${params.end_date}`;
  }

  const response = await GET(url);
  return response.data;
};

// ==================== EXPORT ====================

const analyticsApi = {
  // Dashboard
  getDashboard,
  getSummary,
  getInventoryStats,
  getOrdersStats,
  getCustomersStats,
  getTimeSeries,
  // Financial
  getFinancialDashboard,
};

export default analyticsApi;
